import React from 'react'
// libs
import styled, { css } from 'styled-components'
import { useRouter } from 'hooks/useRouter'
// components
import Tooltip from '@mui/material/Tooltip'
// icons
import LinkIconOrigin from 'src/icons/link-white.svg'
import ListIconOrigin from '@mui/icons-material/FormatListBulletedOutlined'
// themes
import { colors } from 'themes'
// constants
import { PLAN_VIEW_MODE } from 'constants/plan'
// utils
import { darken, size } from 'polished'

// styled
const Wrapper = styled.div`
  display: flex;
  height: 40px;

  #list-icon {
    ${({ $viewMode }) => $viewMode === PLAN_VIEW_MODE.PLAN && `border: 2px solid ${colors.purple300}`};
    > svg > path,
    circle {
      fill: ${({ $viewMode }) => ($viewMode === PLAN_VIEW_MODE.PLAN ? colors.purple300 : colors.white)};
    }
  }

  #link-icon {
    ${({ $viewMode }) => $viewMode === PLAN_VIEW_MODE.STRUCTURED && `border: 2px solid ${colors.purple300}`};
    > svg > path,
    circle {
      fill: ${({ $viewMode }) => ($viewMode === PLAN_VIEW_MODE.STRUCTURED ? colors.purple300 : colors.white)};
    }
  }
`

const IconWrapper = styled.div`
  align-items: center;
  background-color: ${colors.darkBlue400};
  cursor: pointer;
  display: flex;
  height: 40px;
  width: 50px;

  border-radius: ${({ $isListIcon }) => ($isListIcon ? '20px 0 0 20px' : '0 20px 20px 0')};
  justify-content: ${({ $isListIcon }) => ($isListIcon ? 'flex-end' : 'flex-start')};
  padding-right: ${({ $isListIcon }) => ($isListIcon ? '10px' : 'unset')};
  padding-left: ${({ $isListIcon }) => (!$isListIcon ? '10px' : 'unset')};

  ${({ $isActive }) =>
    !$isActive &&
    css`
      &:hover {
        background-color: ${darken(0.1, colors.darkBlue400)};
      }
    `}
`

const ListIcon = styled(ListIconOrigin)`
  && {
    ${size('20px')};
  }
`

const LinkIcon = styled(LinkIconOrigin)`
  && {
    ${size('22px')};
  }
`

const PlanViewModesMenu = () => {
  const [planViewMode, setPlanViewMode] = React.useState(PLAN_VIEW_MODE.STRUCTURED)

  const router = useRouter()

  const handleSetPlanViewMode = (viewMode) => setPlanViewMode(viewMode)

  const setPlanViewModeToRoute = () => {
    const { id, companyId, parentId } = router.query

    router.replace(
      {
        pathname: `/plans/${companyId}/edit/${id}`,
        query: {
          parentId,
          planViewMode
        }
      },
      undefined,
      { shallow: true }
    )
  }

  React.useEffect(() => {
    setPlanViewModeToRoute()
  }, [planViewMode])

  return (
    <Wrapper $viewMode={planViewMode}>
      <Tooltip title='Hide Referenced Items'>
        <IconWrapper
          $isListIcon
          id='list-icon'
          $isActive={planViewMode === PLAN_VIEW_MODE.PLAN}
          onClick={() => handleSetPlanViewMode(PLAN_VIEW_MODE.PLAN)}>
          <ListIcon htmlColor='white' />
        </IconWrapper>
      </Tooltip>
      <Tooltip title='Show Referenced Items'>
        <IconWrapper
          id='link-icon'
          $isActive={planViewMode === PLAN_VIEW_MODE.STRUCTURED}
          onClick={() => handleSetPlanViewMode(PLAN_VIEW_MODE.STRUCTURED)}>
          <LinkIcon />
        </IconWrapper>
      </Tooltip>
    </Wrapper>
  )
}

export default PlanViewModesMenu
